module.exports = __webpack_public_path__ + "static/seo-15ec84be05cb216f5fd6fcab37f5529a.svg";